<template>
	<div class="ai_container">
		<Header :isShowHome="true" />
		<div class="mypage_userinfo_wrapper">
			<div>
				<h5 class="heading_5" @click="mypageUserInfo">{{ userName }}님 안녕하세요!</h5>
				<LoginSocial :provider="'naver'" />
			</div>
			<img src="/static/icons/arrow/arrow_small_bold_right.svg" @click="mypageUserInfo" />
		</div>
		<ul class="mypage_menu_list">
			<li class="body_7_M" @click="handleHistory">견적 내역 보기</li>
			<li class="body_7_M" @click="handleMyCoupon">My 쿠폰</li>
			<li class="body_7_M">마케팅 동의
				<toggle-button
					style="float:right;"
					:value="isMarketingYn"
					@change="onChangeEventHandler"
					color="#82C7EB"
					:sync="true"
					:labels="false"
					:disabled="isToggleDisabled"
					/>
			</li>
			<li class="body_7_M" @click="handleLogout">로그아웃</li>
		</ul>
		<Footer />
	</div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'
import Header from '../../../components/ai/AiHeader.vue'
import Footer from '../../../components/ai/AiFooter.vue'
import LoginSocial from '../../../components/ai/AiLoginSocial.vue'
import { EventBus } from "@/modules/event-bus"
import {ToggleButton} from 'vue-js-toggle-button'

export default {
	components: {
		Header,
		Footer,
		LoginSocial,
		ToggleButton
	},
	data() {
		return {
			termNo:0,
			isToggleDisabled:false,
			isMarketingYn:true,
			isLogin: false,
			userName: Vue.$sessionStorage.get('decriptName'),
			parms: {
				userNo: Vue.$sessionStorage.get('userNo'),
				name: '',
				ci: ''
			},
		}
	},
	methods: {
		getMarketing(){
			Vue.httpClient
			.post('/m/ai/term/getMarketingTerm')
			.then(response => {
				if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
					this.termNo = response.data.result.termNo
					this.isMarketingYn = (response.data.result.termFlag == 'Y')? true:false
					this.isToggleDisabled = (this.termNo == 0)? true:false
				}
			})
		},

		onChangeEventHandler(){

			const params = {
				termFlag : (this.isMarketingYn)?'N':'Y', // 업데이트해야하니 true면 N, false면 Y
				termNo : this.termNo
			}
			Vue.httpClient
			.post('/m/ai/term/updateMarketingTerm', params)
			.then(response => {
				if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
					this.termNo = response.data.result.termNo
					this.isMarketingYn = (response.data.result.termFlag == 'Y')? true:false
					this.isToggleDisabled = (this.termNo == 0)? true:false
				}
			})
		},

		handleClose() {
			//alert('뒤로가기')
			this.$router.go(-1);
		},
		handleHistory() {
			//alert('견적 내역 확인하기')
			this.$router.push({ name: 'AiEstimateList' })
		},
		handleMyCoupon() {
			this.$router.push({ name: 'AiMypageCoupon' })
		},
		handleLogout() {
			//alert('로그아웃')
			Vue.httpClient
				.post(AppConfig.HTTP_CONFIG.authURL + '/m/ai/aiLogout', this.parms)
				.then(response => {
					if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
						window.$store.commit('Login/setToken', { token: null })
						window.$store.commit('Login/setUserNo', { userNo: null })
						Vue.httpClient.defaults.headers.common['x-auth-token'] = null;
						Vue.$sessionStorage.clear();
						EventBus.$emit("ai-event-logout");
						this.$router.go(-1);
					}
				})
		},
		mypageUserInfo() {
			//alert("회원정보");
			this.$router.push({ name: 'AiMypageUserInfo' })
		}
	},
	mounted() {
		this.getMarketing()

		// 마케팅동의여부 체크
	}
}
</script>

<style scoped>
.mypage_userinfo_wrapper {
	display: flex;
	align-items: center;
	justify-content: space-between;
	background-color: var(--gray-scale-12);
	padding: 20px;
}

.mypage_menu_list {
	background-color: var(--gray-scale-12);
}

.mypage_menu_list>li {
	padding: 16px 20px;
}

.mypage_menu_list>li:last-of-type {
	box-shadow: 0.1ch;
}
</style>



// WEBPACK FOOTER //
// src/views/ai/mypage/AiMypage.vue